"use client";

import { create } from "zustand";
import type { SassTrackOrganizationStats } from "./types";
import { ServicesQuota, Transactions } from "database";

type SassTrackState = {
  track: SassTrackOrganizationStats | null;
  organizationId: string;
  bannerDismissed: boolean;
  transactions: (Transactions & { qouta: ServicesQuota })[];
  isOrganizer: boolean;
};

type SassTrackActions = {
  setTrack: (next: SassTrackOrganizationStats | null) => void;
  setOrganizationId: (next: string) => void;
  dismissBanner: () => void;
  resetBanner: () => void;
  setIsOrganizer: (next: boolean) => void;
  hydrate: (args: {
    transactions: (Transactions & { qouta: ServicesQuota })[];
    track?: SassTrackOrganizationStats | null;
    organizationId?: string;
    isOrganizer?: boolean;
  }) => void;
};

export type SassTrackStore = SassTrackState & SassTrackActions;

export const useSassTrackStore = create<SassTrackStore>((set) => ({
  track: null,
  organizationId: "",
  bannerDismissed: false,
  transactions: [],
  isOrganizer: false,
  setIsOrganizer: (isOrganizer) => set({ isOrganizer }),
  setTrack: (track) => set({ track }),
  setOrganizationId: (organizationId) => set({ organizationId }),
  dismissBanner: () => set({ bannerDismissed: true }),
  resetBanner: () => set({ bannerDismissed: false }),
  hydrate: ({ track, organizationId, transactions, isOrganizer }) =>
    set((prev) => ({
      track: track ?? prev.track,
      organizationId: organizationId ?? prev.organizationId,
      transactions: transactions ?? prev.transactions,
      isOrganizer: isOrganizer ?? prev.isOrganizer,
    })),
}));
